query pessoaSelect {
    data: pessoas(order: [{nome: ASC}]) {
        value: codigo
        label: nome
    }
}